import { createSelector } from "reselect";
import { uniqueByKey, memoize } from "@ls/js-utils";
import SelectionState from "state/selections/SelectionState";
import scope from "./scope";

export const selectDefinitions = memoize((selectionState) => {
  if (selectionState === SelectionState.UNCOMMITTED) {
    return (state) => state[scope]["definitions"][selectionState];
  }

  return createSelector(
    (state) => state[scope]["definitions"][selectionState],
    (definitions) => {
      const completeDefinitions = definitions.filter(
        ({ complete }) => complete
      );
      return completeDefinitions.filter(
        uniqueByKey(completeDefinitions, "key")
      );
    }
  );
});

export const selectData = (summaryType) => (state) =>
  state[scope]["data"][summaryType];
export const selectFetchingData = (summaryType) => (state) =>
  state[scope]["fetchingData"][summaryType];
export const selectSbsData = (summaryType) => (state) =>
  state[scope]["sbsData"][summaryType];
export const selectFetchingSbsData = (summaryType) => (state) =>
  state[scope]["fetchingSbsData"][summaryType];
